"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsePanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var CollapseContext_1 = require("./CollapseContext");
var icon_1 = require("../icon");
var config_context_1 = require("../_util/config-context");
var inject_value_1 = require("../_util/inject-value");
var key_map_1 = require("../_util/key-map");
exports.CollapsePanel = react_1.default.forwardRef(function CollapsePanel(_a, ref) {
    var id = _a.id, title = _a.title, children = _a.children, _b = _a.content, content = _b === void 0 ? children : _b, position = _a.position, className = _a.className, props = tslib_1.__rest(_a, ["id", "title", "children", "content", "position", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _c = react_1.useContext(CollapseContext_1.CollapseContext), activeIds = _c.activeIds, onActive = _c.onActive, _d = _c.icon, icon = _d === void 0 ? function (active) { return react_1.default.createElement(icon_1.Icon, { type: active ? "arrowup" : "arrowright" }); } : _d, _e = _c.iconPosition, iconPosition = _e === void 0 ? "left" : _e, destroyInactivePanel = _c.destroyInactivePanel;
    var active = activeIds.includes(id);
    var show = active || !destroyInactivePanel;
    var top = position === "top";
    function handleClick(event) {
        if (active) {
            onActive(activeIds.filter(function (activeId) { return activeId !== id; }), { event: event, activeId: id, active: !active });
        }
        else {
            onActive(tslib_1.__spread(activeIds, [id]), { event: event, activeId: id, active: !active });
        }
    }
    function handleKeyDown(event) {
        if (event.key === key_map_1.KeyMap.Enter) {
            if (active) {
                onActive(activeIds.filter(function (activeId) { return activeId !== id; }), { event: event, activeId: id, active: !active });
            }
            else {
                onActive(tslib_1.__spread(activeIds, [id]), { event: event, activeId: id, active: !active });
            }
        }
    }
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-accordion", className, {
            "is-active": active,
        }) }, props),
        top && show && (react_1.default.createElement("div", { className: classPrefix + "-accordion__body" }, content)),
        react_1.default.createElement("div", { className: classPrefix + "-accordion__header", tabIndex: 0, role: "button", onClick: handleClick, onKeyDown: handleKeyDown },
            iconPosition !== "right" && inject_value_1.injectValue(icon)(active),
            react_1.default.createElement("span", { className: classPrefix + "-accordion__header-title" }, inject_value_1.injectValue(title)(active)),
            iconPosition === "right" && inject_value_1.injectValue(icon)(active)),
        !top && show && (react_1.default.createElement("div", { className: classPrefix + "-accordion__body" }, content))));
});
exports.CollapsePanel.displayName = "CollapsePanel";
//# sourceMappingURL=CollapsePanel.js.map